import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AdvisorProfileModel} from '../../@models/api/advisor-profile/advisor-profile.model';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class ApiAdvisorProfileService {

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    /**
     * Primary advisor profile
     */
    public getPrimary(): Observable<AdvisorProfileModel> {
        return this.httpClient.get<AdvisorProfileModel>(`${environment.ApolloApiUrl}/AdvisorProfile/Primary`);
    }
}
